import intermediaryApplicationsPagination from 'components/LoanOriginationSystem/IntermediaryDetails/pagination';
import { SimplifiedApplicationsApi } from 'api/LoanOriginationSystem/SimplifiedApplicationsApi';

const IntermediaryApplicationsPaginationMiddleware = (api: SimplifiedApplicationsApi) => {
  return intermediaryApplicationsPagination.getItemsFetcherMiddleware(async (params) => {
    return api.getIntermediaryApplications(
      params.intermediaryId,
      {
        count: params.perPage,
        offset: (params.page - 1) * params.perPage,
      },
      params.sortingType,
    );
  });
};

export default IntermediaryApplicationsPaginationMiddleware;
